import { createContext } from 'react';
var LazyContext = /*#__PURE__*/createContext({
  strict: false
});
export { LazyContext };